export default {
  /**
   * Trạng thái của form
   */
  FormState: {
    Add: "Thêm mới",
    View: "Xem",
    Edit: "Sửa",
    Duplicate: "Nhân bản",
    QuickAdd: "Thêm nhanh"
  },
  /**
   * Giới tính
   */
  Gender: {
    Female: "Nữ",
    Male: "Nam",
    Other: "Khác"
  },
  /**
   * toán tử filter
   */
  FilterHeader: {
    Contains: "Chứa",
    Notcontains: "Không chứa",
    StartsWith: "Bắt đầu với",
    EndsWith: "Kết thúc với",
    Null: "(Trống)",
    NotNull: "(Không trống)",
    Equals: "Bằng",
    NotEquals: "Khác",
    GreaterThan: "Lớn hơn",
    GreaterThanEquals: "Lớn hơn hoặc bằng",
    LessThan: "Nhỏ hơn",
    LessThanEquals: "Nhỏ hơn hoặc bằng",
    Between: "Trong khoảng"
  },

  OrganizationUnitType: {
    Corporations: "Tổng công ty",
    Group: "Tập đoàn",
    Subsidiaries: "Công ty con",
    Branch: "Chi nhánh",
    Representative: "Văn phòng đại điện",
    Office: "Văn phòng",
    Center: "Trung tâm",
    Department: "Phòng ban",
    Team: "NHóm/tổ/đội",
    Factory: "Phân xưởng"
  },
  EmployeeType: {
    Probation: "Thử việc",
    Office: "Chính thức",
    Manage: "Quản lý",
  }
};
